// src/pages/tag/TagSettingsPage.tsx
// Auto-generated by corebuilder. Edit freely.

import { useState } from 'react';
import { Link } from 'react-router-dom';
import { observer } from '@react';
import { useTag, useI18n } from '@react/hooks';
import {
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
  Alert,
  ErrorAlert,
} from '@react/components';

/**
 * Tag settings page.
 * Features:
 * - i18n via useI18n hook
 * - Semantic color tokens (theme-aware, dark mode ready)
 * - Customize with service-specific settings
 */
export const TagSettingsPage = observer(() => {
  const store = useTag();
  const { t } = useI18n();
  const [saved, setSaved] = useState(false);

  const handleSave = async () => {
    // TODO: Implement settings save logic
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="space-y-6">
      {/* Page header */}
      <div>
        <nav className="text-sm mb-2">
          <Link to="/tags" className="text-muted-foreground hover:text-foreground">
            {t('tag.list')}
          </Link>
          <span className="mx-2 text-muted-foreground">/</span>
          <span className="text-foreground">{t('tag.settings')}</span>
        </nav>
        {/* The tab already names this page; the heading stays for screen readers. */}
        <h1 className="sr-only">{t('tag.settings')}</h1>
      </div>

      {/* Success notification */}
      {saved && (
        <Alert variant="success" dismissible onDismiss={() => setSaved(false)}>
          {t('tag.saveSuccess')}
        </Alert>
      )}

      {/* Error state */}
      {store.error ? <ErrorAlert error={store.error} dismissible onDismiss={() => store.clearError()} /> : null}

      {/* Notification Preferences */}
      <Card>
        <CardHeader>
          <CardTitle>Notification Preferences</CardTitle>
          <CardDescription>Choose how you want to be notified about tag events.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {/* TODO: Add notification preference toggles */}
          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              defaultChecked
              className="h-4 w-4 rounded border-input text-primary focus:ring-ring"
            />
            <span className="text-sm text-foreground">Email notifications</span>
          </label>
          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              defaultChecked
              className="h-4 w-4 rounded border-input text-primary focus:ring-ring"
            />
            <span className="text-sm text-foreground">Push notifications</span>
          </label>
        </CardContent>
      </Card>

      {/* Display Preferences */}
      <Card>
        <CardHeader>
          <CardTitle>Display Preferences</CardTitle>
          <CardDescription>Customize how tag data is displayed.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {/* TODO: Add display preference controls */}
          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              defaultChecked
              className="h-4 w-4 rounded border-input text-primary focus:ring-ring"
            />
            <span className="text-sm text-foreground">Compact list view</span>
          </label>
          <label className="flex items-center gap-3">
            <input
              type="checkbox"
              className="h-4 w-4 rounded border-input text-primary focus:ring-ring"
            />
            <span className="text-sm text-foreground">Advanced fields</span>
          </label>
        </CardContent>
        <CardFooter className="flex justify-end">
          <Button onClick={handleSave}>{t('common.save')}</Button>
        </CardFooter>
      </Card>
    </div>
  );
});

export default TagSettingsPage;
